
export const buildPageUrl = (data?: {
    slug: string
    category?: {
        slug: string
    }
}) => {
    if (!data) {
        return undefined
    }
    return "/" + [
        ...data?.category?.slug ? [data?.category?.slug] : [],
        ...data?.slug ? [data?.slug] : []].join("/")
}